import dayjs from 'dayjs'
import React from 'react'
import styled from 'styled-components'
import { SensorScatterplotData } from 'types'

const TimestampHeader = styled.div`
  margin-bottom: 0.5rem;
  font-weight: 600;
`

interface TooltipTimestampProps {
  tableData: SensorScatterplotData[]
}

export const TooltipTimestamp: React.FC<TooltipTimestampProps> = ({
  tableData,
}) => {
  const firstItem = tableData.find((item) => item.xValue !== null)
  const timestamp = firstItem?.xValue

  if (timestamp && typeof timestamp === 'string') {
    return (
      <TimestampHeader>
        {dayjs(timestamp).format('MMM D, HH:mm:ss')}
      </TimestampHeader>
    )
  } else if (timestamp && typeof timestamp === 'number') {
    const formattedTimestamp = dayjs(new Date(timestamp)).format(
      'MMM D, HH:mm:ss'
    )
    return <TimestampHeader>{formattedTimestamp}</TimestampHeader>
  }

  return null
}
